import React from 'react'
import PropTypes from 'prop-types'
import { debounce, flowRight } from 'lodash'
import Styles from './index.scss'

const SearchBox = props => (
  <div className="pull-left">
    <form
      name="filter-form"
      onSubmit={props.onSubmitFilter(props.user.filter.email, props.user.filter.country)}
      style={{ display: 'inline-table' }}
    >
      <div className={`${Styles['search-box']} form-group`}>
        <div className={`search-bar ${Styles.addPadding}`}>
          <input
            className={`${Styles.searchBar} form-control`}
            name="searchProfileField"
            type="text"
            placeholder="Search By Email"
            onChange={
              flowRight(
                debounce(props.setEmailFilter(props.user.filter.country), 300),
                e => e.persist() || e)
            }
            value={props.searchProfileField}
          />
        </div>
      </div>
    </form>
  </div>
)

SearchBox.propTypes = {
  onSubmitFilter: PropTypes.func.isRequired,
  user: PropTypes.shape({
    filter: PropTypes.shape({
      email: PropTypes.string,
      country: PropTypes.string,
    }).isRequired,
  }).isRequired,
  setEmailFilter: PropTypes.func.isRequired,
  searchProfileField: PropTypes.string.isRequired,
}

export default SearchBox
